import React from "react";
import { BUSINESSES } from "@/data/gameData";
import Avatar from "@/components/avatar/Avatar";
import Mascot from "@/components/avatar/Mascot";

const FlyerPreview = ({ businessId, design, avatar, playerName, brand }) => {
  const biz = BUSINESSES[businessId];
  const contactLabel = design.contact?.trim() || "Contact my parent";
  const phone = design.phone?.trim() || "____________";
  const color = brand?.color || biz.primary;
  const logo = brand?.logo && brand.logo !== "avatar" ? brand.logo : biz.emoji;
  return (
    <div
      className="flyer-print bg-white text-slate-900 rounded-2xl overflow-hidden border-4 shadow-xl mx-auto w-full max-w-[420px]"
      style={{ borderColor: color, fontFamily: "inherit" }}
      data-testid="flyer-preview"
    >
      <div className="p-5 text-white text-center" style={{ backgroundColor: color }}>
        <div className="text-[11px] font-black uppercase tracking-[0.3em] opacity-90">{logo} {biz.name} for hire {logo}</div>
        <h2 className="font-display text-3xl sm:text-4xl font-bold leading-tight mt-1 break-words" data-testid="flyer-headline">
          {design.headline}
        </h2>
        <p className="font-heading font-bold text-sm mt-1 opacity-95">{design.slogan}</p>
      </div>

      <div className="p-5 flex gap-4 items-center">
        <div className="shrink-0 flex flex-col items-center">
          <Avatar avatar={avatar} size={90} testid="flyer-avatar" />
          {design.showMascot && <Mascot pet={avatar.pet} size={48} testid="flyer-mascot" />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1">What I do</div>
          <ul className="space-y-1">
            {design.services.filter((s) => s.trim()).map((s, i) => (
              <li key={`${i}-${s}`} className="font-heading font-bold text-sm flex gap-2 items-start">
                <span style={{ color: color }}>✔</span>
                <span className="break-words">{s}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mx-5 mb-4 rounded-2xl border-4 border-dashed p-3 text-center" style={{ borderColor: color }}>
        <div className="text-[10px] font-black uppercase tracking-widest text-slate-500">Price</div>
        <div className="font-display text-3xl font-bold" style={{ color: color }} data-testid="flyer-price">
          Starting at ${design.price}
        </div>
      </div>

      <div className="px-5 pb-4 text-center">
        <div className="font-heading font-black text-sm">Ask for {playerName}!</div>
        <div className="text-xs font-bold text-slate-600 mt-0.5" data-testid="flyer-contact-line">
          {contactLabel}: <span className="text-slate-900">☎ {phone}</span>
        </div>
        <div className="text-[10px] font-bold text-slate-400 mt-1">I always work with a grown-up nearby 🛡️</div>
      </div>

      {design.showTabs && (
        <div className="grid grid-cols-5 border-t-2 border-dashed border-slate-300" data-testid="flyer-tabs">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={`tab-${i}`} className="border-r-2 border-dashed border-slate-300 last:border-r-0 py-2 text-center" data-testid={`flyer-tab-${i}`}>
              <div className="text-[9px] font-black uppercase leading-tight break-words px-0.5" style={{ color: color }}>
                {design.headline}
              </div>
              <div className="text-[9px] font-bold text-slate-500">${design.price}</div>
              <div className="text-[8px] font-black text-slate-700 leading-tight px-0.5 break-words">☎ {phone}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FlyerPreview;
